import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSocket } from "../context/SocketContext";

export default function Home() {
  const navigate = useNavigate();
  const { liveUser, status, joinLive, clearLive } = useSocket();

  const [input, setInput] = useState(liveUser || "");
  const [sinCaja, setSinCaja] = useState([]);

  const stateText = status?.state || "idle";
  const errorText = status?.error ? ` - ${String(status.error)}` : "";

  useEffect(() => {
    fetch("/api/users/sin-caja")
      .then(r => r.json())
      .then(data => setSinCaja(Array.isArray(data) ? data : []))
      .catch(() => {});
  }, []);

  return (
    <div className="card">
      <h1 className="cardTitle">Inicio</h1>

      <div style={{ display: "flex", gap: 10, marginTop: 8, flexWrap: "wrap" }}>
        <input className="input" value={input} onChange={e => setInput(e.target.value)}
          placeholder="Usuario TikTok LIVE (sin @)" style={{ flex: 1, minWidth: 200 }}
          onKeyDown={e => e.key === "Enter" && joinLive(input)} />
        <button className="btn btn-primary" onClick={() => joinLive(input)} disabled={!input.trim()}>Conectar</button>
        <button className="btn btn-outline" onClick={clearLive} disabled={!liveUser}>Limpiar</button>
      </div>

      <div className="hr" />
      <p><strong>Usuario guardado:</strong> {liveUser || "(ninguno)"}</p>
      <p><strong>Estado:</strong> {stateText}{errorText}</p>

      {sinCaja.length > 0 && (
        <div style={{ margin: "4px 0 12px", padding: "12px 16px", borderRadius: "var(--radius-sm)", background: "#fff8e1", border: "1px solid #f5c842", display: "flex", alignItems: "center", gap: 14, flexWrap: "wrap" }}>
          <div style={{ fontSize: 22 }}>⚠️</div>
          <div style={{ flex: 1 }}>
            <div style={{ fontWeight: 700, marginBottom: 4 }}>{sinCaja.length} usuario{sinCaja.length > 1 ? "s" : ""} sin caja asignada</div>
            <div style={{ display: "flex", flexWrap: "wrap", gap: 6 }}>
              {sinCaja.map(u => (
                <span key={u.id} style={{ background: "#fff", border: "1px solid #f5c842", borderRadius: 6, padding: "2px 10px", fontSize: 13, fontWeight: 600 }}>{u.displayName}</span>
              ))}
            </div>
          </div>
          <button className="btn btn-outline" style={{ whiteSpace: "nowrap" }} onClick={() => navigate("/usuarios")}>Asignar cajas</button>
        </div>
      )}

      <div className="hr" />

      <div className="grid2">
        <button className="btn btn-primary" onClick={() => navigate("/directo")} disabled={!liveUser}>
          ⚡ Directo
        </button>
        <button className="btn btn-outline" onClick={() => navigate("/comentarios")} disabled={!liveUser}>
          💬 Comentarios
        </button>
        <button className="btn btn-outline" onClick={() => navigate("/usuarios")}>
          👥 Usuarios
        </button>
        <button className="btn btn-outline" onClick={() => navigate("/datos")}>
          📊 Datos
        </button>
        <button className="btn btn-outline" onClick={() => navigate("/cajas")}>
          📦 Cajas
        </button>
        <button className="btn btn-outline" onClick={() => navigate("/tv")} disabled={!liveUser}>
          📺 TV
        </button>
      </div>

      {!liveUser && (
        <p className="muted" style={{ marginTop: 14 }}>Primero conecta un usuario LIVE para habilitar las demás pantallas.</p>
      )}
    </div>
  );
}
